import React from "react";
import Modal from "react-bootstrap/Modal";
import PropTypes from "prop-types";
import _Button from "../../../generic/_Button";
import { useQuery } from "@tanstack/react-query";
import { httpClient } from "../../../../utils/HttpClient";
import { ApiEndpoint } from "../../../../utils/ApiEndpoint";
import { useAuth } from "../../../../Context/AuthContext";
import { Table } from "../../../ui/Table";
import { FormatInt } from "../../../../utils/FormatData";

const columns = [
  {
    Header: "Partner",
    accessor: "vc_partner",
  },
  {
    Header: "Enviados",
    accessor: "i_sent",
    Cell: (rowData) => {
      let value = rowData.row.original.i_sent;

      return FormatInt(value);
    },
  },
  {
    Header: "Válidos",
    accessor: "i_valids",
    Cell: (rowData) => {
      let value = rowData.row.original.i_valids;

      return FormatInt(value);
    },
  },
  {
    Header: "No Válidos",
    accessor: "i_novalids",
    Cell: (rowData) => {
      let value = rowData.row.original.i_novalids;

      return FormatInt(value);
    },
  },
  {
    Header: "Respuestas",
    accessor: "i_responses",
    Cell: (rowData) => {
      let value = rowData.row.original.i_responses;

      return FormatInt(value);
    },
  },
  {
    Header: "Por Procesar",
    accessor: "i_pending",
    Cell: (rowData) => {
      let value = rowData.row.original.i_pending;

      return FormatInt(value);
    },
  },
  {
    Header: "Errores",
    accessor: "i_errors",
    Cell: (rowData) => {
      let value = rowData.row.original.i_errors;

      return FormatInt(value);
    },
  },
];

const _ModalHealthApi = (props) => {
  const { visible = false, onClose, title = "", loading = false } = props;
  const auth = useAuth();
  const { token } = auth.getSessionData();
  const { isPending, data } = useQuery({
    queryKey: ["healthApi"],
    queryFn: async () => {
      const response = await httpClient(
        "GET",
        `${ApiEndpoint}dashboard/requestsapidetail`,
        {},
        token
      );
      return await response.data;
    },
    enabled: visible,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });

  const _onClose = () => {
    if (onClose) onClose();
  };
  return (
    <Modal show={visible} onHide={_onClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <div className="text-xl font-semibold text-gray-600">{title}</div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table
          columns={columns}
          data={data}
          loading={isPending}
          config={{
            search: true,
            pageSize: 10,
            perPage: 10,
            pagination: true,
            rowInfo: false,
            navButtons: false,
            rowsPerPageSelection: false,
            footer: true,
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <_Button
          title="Cerrar"
          style="primary"
          onClick={_onClose}
          loading={loading}
          disabled={loading}
        />
      </Modal.Footer>
    </Modal>
  );
};

_ModalHealthApi.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  loading: PropTypes.bool,
};
export default _ModalHealthApi;
